import * as React from "react";
import PropTypes from 'prop-types';

const SvgStarsNew = props => {
  if (props.id !== "_svgstarsnew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 78 13" {...props}><g fillRule="evenodd"><path d="M71 10.5l-4.114 2.163.785-4.581-3.328-3.245 4.6-.669L71 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581zM55 10.5l-4.114 2.163.785-4.581-3.328-3.245 4.6-.669L55 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581zM39 10.5l-4.114 2.163.785-4.581-3.328-3.245 4.6-.669L39 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581zM23 10.5l-4.114 2.163.785-4.581-3.328-3.245 4.6-.669L23 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581zM7 10.5l-4.114 2.163.785-4.581L.343 4.837l4.6-.669L7 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581z" /></g></svg>;
};

SvgStarsNew.displayName = "_svgstarsnew";
SvgStarsNew.propTypes = {
  id: PropTypes.string
};
SvgStarsNew.defaultProps = {
  id: ''
};
export default SvgStarsNew;